import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Modal,
  TextField,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import { tokens } from "../../theme";
import ModalCharge from "../../modal/modalCharge";
// import LoadingSpinner from "../../loadingSpinner";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import ModalProducto from "../../modal/producto/modalProducto";
import { putDatosLiberacion } from "../../services/pedidoVenta.services.js";
import ModalCliente from "../../modal/cliente/modalCliente";
import ModalCamion from "../../modal/camiones/modalCamion";
import secureStorage from "../../utils/secureStorage";


const ModalEditarPedido = ({ open, onClose, dataNota, pedidoId, pedidoResumen, onUpdated }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [notaEditada, setNotaEditada] = useState({});
  const [productos, setProductos] = useState([]);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [modalProductoOpen, setModalProductoOpen] = useState(false);
  const [productoIndexSeleccionado, setProductoIndexSeleccionado] = useState(null);
  const [modalClienteOpen, setModalClienteOpen] = useState(false);
  const [modalCamionOpen, setModalCamionOpen] = useState(false);
  const [pais, setPais] = useState(null);

  const User = Number.parseInt(secureStorage.getItem("id"), 10);
  

  useEffect(() => {
    if (Array.isArray(dataNota) && dataNota.length > 0) {
      const productosFormateados = dataNota.map((item) => ({
        ...(pedidoResumen ?? {}),
        ...item,
      }));
      const primeraFila = {
        ...(pedidoResumen ?? {}),
        ...dataNota[0],
      };
      setProductos(productosFormateados);
      setNotaEditada(primeraFila);
      return;
    }

    if (pedidoResumen) {
      setProductos([]);
      setNotaEditada({ ...pedidoResumen });
      return;
    }

    setProductos([]);
    setNotaEditada({});
  }, [dataNota, pedidoResumen]);

  
const handleProductoChange = (index, field, value) => {
  const nuevosProductos = [...productos];
  nuevosProductos[index][field] =
    field === "cantidad" ? parseInt(value, 10) || 0 : value;

  setProductos(nuevosProductos);

  if (field === "cantidad") {
    const total = nuevosProductos.reduce((acc, prod) => {
      const cantidad = parseInt(prod.cantidad);
      return acc + (isNaN(cantidad) ? 0 : cantidad);
    }, 0);

    setNotaEditada((prev) => ({
      ...prev,
      cantidad_total: total,
      id_usuario: User,
    }));
  }
};

  const handleNotaChange = (field, value) => {
    setNotaEditada(prev => ({ ...prev, [field]: value }));
  };
  

  const handleGuardarCambios = async () => {
    setIsLoading(true);
    setRegistrationError(false);
    setRegistrationSuccess(false);
    setError("");

    try {
      const resolvedPedidoId = pedidoId ?? notaEditada?.n_pedido ?? notaEditada?.id_pedido;
      if (!resolvedPedidoId) {
        setError("No se pudo identificar la nota fiscal a actualizar");
        setRegistrationError(true);
        return;
      }

      const storedCodEmpresa = Number.parseInt(secureStorage.getItem("cod_empresa"), 10);
      const firstProducto = productos[0] ?? {};
      const resolvedVehiculoRaw =
        notaEditada?.id_vehiculo ??
        firstProducto.id_vehiculo ??
        firstProducto.idVehiculo ??
        pedidoResumen?.id_vehiculo ??
        pedidoResumen?.idVehiculo;
      const resolvedClienteRaw =
        notaEditada?.id_cliente ??
        firstProducto.id_cliente ??
        firstProducto.idCliente ??
        pedidoResumen?.id_cliente ??
        pedidoResumen?.idCliente;
      // const resolvedFormaPago =
      //   notaEditada?.formaDePago ??
      //   notaEditada?.forma_pago ??
      //   firstProducto.formaDePago ??
      //   firstProducto.forma_pago ??
      //   pedidoResumen?.formaDePago ??
      //   pedidoResumen?.forma_pago ??
      //   "";

      const resolvedVehiculo = Number(resolvedVehiculoRaw);
      const resolvedCliente = Number(resolvedClienteRaw);

      if (Number.isNaN(storedCodEmpresa) || storedCodEmpresa <= 0) {
        setError("Falta el código de empresa");
        setRegistrationError(true);
        return;
      }

      if (Number.isNaN(resolvedVehiculo) || resolvedVehiculo <= 0) {
        setError("Debes seleccionar un vehículo válido");
        setRegistrationError(true);
        return;
      }

      if (Number.isNaN(resolvedCliente) || resolvedCliente <= 0) {
        setError("Debes seleccionar un cliente válido");
        setRegistrationError(true);
        return;
      }

      // if (!resolvedFormaPago) {
      //   setError("Debes indicar la forma de pago");
      //   setRegistrationError(true);
      //   return;
      // }

      if (Number.isNaN(User) || User <= 0) {
        setError("No se encontró el usuario actual");
        setRegistrationError(true);
        return;
      }

      const lineItems = [];

      for (const producto of productos) {
        const rawProductId =
          producto.producto_id ??
          producto.id_producto ??
          producto.idProducto ??
          producto.id;
        const rawCantidad = producto.cantidad ?? producto.cantidad_total ?? 0;
        const rawDetalleId =
          producto.id_detalle ??
          producto.detalle_id ??
          producto.detalleId ??
          producto.id;
        const rawNumeroPedido =
          producto.n_pedido ??
          pedidoResumen?.n_pedido ??
          resolvedPedidoId;

        const productId = Number(rawProductId);
        const cantidad = Number(rawCantidad);
        const detalleId = Number(rawDetalleId);
        const numeroPedido =
          typeof rawNumeroPedido === "string"
            ? rawNumeroPedido
            : Number.isNaN(Number(rawNumeroPedido))
            ? String(rawNumeroPedido ?? "")
            : Number(rawNumeroPedido);

        if (Number.isNaN(productId) || productId <= 0) {
          setError("Hay productos sin identificador válido");
          setRegistrationError(true);
          return;
        }

        if (Number.isNaN(cantidad) || cantidad <= 0) {
          setError("La cantidad debe ser mayor a cero para todos los productos");
          setRegistrationError(true);
          return;
        }

        if (Number.isNaN(detalleId) || detalleId <= 0) {
          setError("Hay ítems sin identificador de detalle válido");
          setRegistrationError(true);
          return;
        }

        if (!numeroPedido) {
          setError("No se pudo determinar el número de pedido para algunos productos");
          setRegistrationError(true);
          return;
        }

        lineItems.push({
          id: detalleId,
          n_pedido: numeroPedido,
          id_producto: productId,
          cantidad,
        });
      }

      if (lineItems.length === 0) {
        setError("Debes agregar al menos un producto");
        setRegistrationError(true);
        return;
      }

      const payload = {
        cod_empresa: storedCodEmpresa,
        id_usuario: User,
        id_vehiculo: resolvedVehiculo,
        // formaDePago: resolvedFormaPago,
        id_cliente: resolvedCliente,
        data: lineItems,
      };

      await putDatosLiberacion(resolvedPedidoId, payload);

      setRegistrationSuccess(true);
      if (typeof onUpdated === "function") {
        onUpdated();
      }
    } catch (error) {
      console.error("Error al enviar los datos", error);
      setRegistrationError(true);
      setError(error.message ?? "Ocurrió un error al actualizar la nota");
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 1500);
    }
  };


  const handleCloseModal = () => {
    setRegistrationSuccess(false);
  };

  const handleCloseModalError = () => {
    setRegistrationError(false);
  };

  const openModalCliente = () => {
    setModalClienteOpen(true); // Abrir modal de productos
  };

  const handleSelectCliente = (cliente) => {
    setNotaEditada(prev => ({
      ...prev,
      id_cliente: cliente.id,
      descripcion_cliente: cliente.descripcion,
    }));

    setPais(cliente.pais);

    setModalClienteOpen(false); // Cerrar el modal de productos
  };


  const openModalCamion = () => {
    setModalCamionOpen(true); // Abrir modal de productos
  };

const handleSelectCamion = (camion) => {

  // Asignar id_vehiculo a cada producto
  const productosActualizados = productos.map((producto) => ({
    ...producto,
    id_vehiculo: camion.id, // asegurate que sea 'camion.id'
    chapa: camion.chapa, // asignar el chofer al producto
  }));

  setProductos(productosActualizados);

  // También podés asignar el vehículo al encabezado si es necesario
  setNotaEditada(prev => ({
    ...prev,
    id_vehiculo: camion.id,
    chapa: camion.chapa,
  }));

  setModalCamionOpen(false);
};

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-nota-fiscal"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
      }}
    >
      <Box
        sx={{
          backgroundColor: colors.primary[600],
          padding: "20px",
          maxHeight: "90vh",
          overflowY: "auto",
          width: "90%",
          maxWidth: "1200px",
          borderRadius: "8px",
        }}
      >
        <Typography variant="h2" mb={2} color={colors.grey[100]}>
          Pedido de Venta - Editar Nota Fiscal 
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              variant="filled"
              label="Cliente"
              value={notaEditada?.cliente || ""}
              onChange={(e) => handleNotaChange("cliente", e.target.value)}
              // onClick={openModalCliente}
              InputProps={{ readOnly: true }}

            />
            
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              variant="filled"
              label="Vehículo"
              value={notaEditada?.chapa || ""}
              onChange={(e) => handleNotaChange("id_vehiculo", e.target.value)}
              InputProps={{ readOnly: true }}
              onClick={openModalCamion}
            />
          </Grid>

        </Grid>

        {/* Productos */}
        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2, marginTop: 4 }}>
          <Typography variant="h3" color={colors.grey[100]}>
            Productos
          </Typography>
        </Box>

        <Box mt={4}>
          
          {productos.map((producto, index) => (
            <Grid
              container
              spacing={2}
              key={producto.id}
              sx={{ mb: 2, pb: 1}}
            >
              <Grid item xs={8}>
                <TextField
                  fullWidth
                  label="Código"
                  value={producto.cod ?? producto.producto ?? ""}
                  onChange={(e) =>
                    handleProductoChange(index, "cod", e.target.value)
                  }
                  onClick={() => {
                    setProductoIndexSeleccionado(index); // guardás el índice seleccionado
                    setModalProductoOpen(true); // abrís el modal
                  }}
                  InputProps={{ readOnly: true }} 

                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Cantidad"
                  value={producto.cantidad || ""}
                  onChange={(e) =>
                    handleProductoChange(index, "cantidad", e.target.value)
                  }
                />
              </Grid>
            </Grid>
          ))}
        </Box>

        <Box display="flex" justifyContent="flex-end" mt={3}>
          <Button
            onClick={onClose}
            color="secondary"
            variant="contained"
            sx={{
              border: "none",
              color: "black",
              height: "7vh",
              width: "10vw",
              borderRadius: "20px",
              cursor: "pointer",
              marginRight: "1vw",
            }}
          >
            Cerrar
          </Button>
          <Button
            onClick={handleGuardarCambios}
            color="primary"
            variant="contained"
            sx={{
              backgroundColor: "rgb(206, 220, 0)",
              border: "none",
              color: "black",
              height: "7vh",
              width: "10vw",
              borderRadius: "20px",
              cursor: "pointer",
              marginRight: "1vw",

              "&:hover": { backgroundColor: "#bac609" },
            }}
          >
            Guardar Cambios
          </Button>
        </Box>
        <ModalCharge isLoading={isLoading} />

        {registrationSuccess && (
          <ModalSucces open={registrationSuccess} onClose={handleCloseModal} />
        )}
        {registrationError && (
          <ModalError
            open={registrationError}
            onClose={handleCloseModalError}
            error={error}
          />
        )}
        
        <ModalProducto
          open={modalProductoOpen} // Estado del modal de productos
          onClose={() => setModalProductoOpen(false)} // Cerrar el modal de productos
          onSelectProduct={(producto) => {
            if (productoIndexSeleccionado !== null) {
              handleProductoChange(productoIndexSeleccionado, "cod", producto.cod);
              handleProductoChange(productoIndexSeleccionado, "producto_id", producto.id); 
              handleProductoChange(productoIndexSeleccionado, "id_producto", producto.id);
              handleProductoChange(productoIndexSeleccionado, "descripcion", producto.descripcion);
              handleProductoChange(productoIndexSeleccionado, "producto", producto.descripcion);
              handleProductoChange(productoIndexSeleccionado, "medidas", producto.medidas);
              setModalProductoOpen(false);
              setProductoIndexSeleccionado(null);
            }
          }}
        />
        <ModalCliente
          open={modalClienteOpen} // Estado del modal de clientes
          onClose={() => setModalClienteOpen(false)} // Cerrar el modal de clientes
          onSelect={(cliente) =>
            handleSelectCliente(cliente, setNotaEditada)
          } // Lógica para seleccionar productos
        />

        <ModalCamion
          open={modalCamionOpen} // Estado del modal de Camions
          onClose={() => setModalCamionOpen(false)} // Cerrar el modal de Camions
          onSelectVehiculos={(Camion) =>
            handleSelectCamion(Camion, setNotaEditada)
          } // Lógica para seleccionar productos
        />
      </Box>
    </Modal>
  );
};

export default ModalEditarPedido;
